import React from "react";
import styled from "styled-components";

/** Petit interrupteur "vs précédent" */
const CompareToggle = ({ on, onToggle, label = "vs précédent" }) => {
    return (
        <Wrapper
            className={on ? "on" : ""}
            onClick={onToggle}
            role="switch"
            aria-checked={on}
        >
            <Switch />
            <Label>{label}</Label>
        </Wrapper>
    );
};

export default CompareToggle;

const Switch = styled.span`
    width: 26px;
    height: 14px;
    border-radius: 7px;
    background: var(--prh-violet-line);
    position: relative;
    transition: background 0.15s;
    flex: none;
    &::after {
        content: "";
        position: absolute;
        top: 2px;
        left: 2px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #fff;
        transition: left 0.15s;
    }
`;

const Label = styled.span`
    font-size: var(--prh-font-sm);
    color: var(--prh-muted);
`;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 7px;
    cursor: pointer;
    user-select: none;
    flex: none;
    margin-top: 4px;

    &.on ${Switch} {
        background: var(--prh-violet);
    }
    &.on ${Switch}::after {
        left: 14px;
    }
    &.on ${Label} {
        color: var(--prh-violet-dark);
        font-weight: 600;
    }
`;
